export default __webpack_public_path__ + "static/media/project1.fe4c65bc.svg";